import { PieChart, Pie, Tooltip, ResponsiveContainer } from "recharts";

export default function GastoCategoriaChart({ data }) {
    return (
        <div style={{ width: "100%", height: 300 }}>
            <h3>Gastos por Categoría</h3>
            <ResponsiveContainer>
                <PieChart>
                    <Pie data={data} dataKey="monto" nameKey="categoria" outerRadius={100} />
                    <Tooltip />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
}